import { fetchData } from '@umu/umu-fetch';
import API from '../../path';

export const getCourseSortFlag = (group_id: string): Promise<1 | 2> => {
    return fetchData(API.N_GET_COURSE_INFO, { group_id })
        .then((res: IResponse<{ session_sort_flag: number }>) => {
            return res.data?.session_sort_flag ?? 1;
        })
        .catch(() => {
            return 1;
        });
};
